import { MessageCircle } from "lucide-react";
import { forwardRef } from "react";

const WhatsAppButton = forwardRef<HTMLAnchorElement>((_props, ref) => {
  return (
    <a
      ref={ref}
      href="https://wa.me/971502112584"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact us on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white px-5 py-3 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 group"
    >
      <MessageCircle className="w-5 h-5" fill="white" strokeWidth={0} />
      <span className="text-sm font-body font-medium tracking-wide hidden sm:inline">
        WhatsApp
      </span>
    </a>
  );
});

WhatsAppButton.displayName = "WhatsAppButton";

export default WhatsAppButton;
